import { Observable } from 'rxjs';
import { SubaccountsRepository, Subaccount, UpdateSubaccountDto } from '../domain/subaccounts/repository';
import HttpClient from '../utils/http-client';
import { ApiResponse, Filter, PaginationData } from '@/domain/pagination/models';

export class SubaccountsRepositoryImplementation extends SubaccountsRepository {
    getSubaccounts(page: number, limit: number, filters: Filter[]): Observable<ApiResponse<PaginationData<Subaccount[]>>> {
        const httpClient = new HttpClient("", "");
        // Construct query string manually or use a helper if available, matching the pattern in other repos
        // The user asked for: http://localhost:5001/api/pos/subaccounts?page=1&limit=10
        // HttpClient likely prepends the base URL.

        let queryParams = `?page=${page}&limit=${limit}`;
        if (filters && filters.length > 0) {
            const filterStr = filters.map(f => `&${encodeURIComponent(f.label)}=${encodeURIComponent(f.value)}`).join('');
            queryParams += filterStr;
        }

        return httpClient.get<ApiResponse<PaginationData<Subaccount[]>>>(`/accounting/subaccounts${queryParams}`);
    }

    updateSubaccount(id: number, data: UpdateSubaccountDto): Observable<ApiResponse<Subaccount>> {
        const httpClient = new HttpClient("", "");
        return httpClient.put<ApiResponse<Subaccount>>(`/accounting/subaccounts/${id}`, data);
    }

    deleteSubaccount(id: number): Observable<ApiResponse<void>> {
        const httpClient = new HttpClient("", "");
        return httpClient.delete<ApiResponse<void>>(`/accounting/subaccounts/${id}`);
    }
}
